"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationRules = exports.getPatternMatchErrorMessage = void 0;

var _validator = require("../validator");

var _messagesI18n = require("../messages-i18n");

var apiValidationRules = function apiValidationRules(_) {
  return [{
    attributes: ['id'],
    condition: _validator.REQUIRED,
    message: function message(attribute) {
      return getRequiredErrorMessage(attribute, _);
    },
    on: ['create']
  }, {
    attributes: ['id'],
    condition: _validator.MATCH_PATTERN,
    pattern: /^([a-z0-9]+\.?)+$/,
    message: function message(attribute) {
      return getPatternMatchErrorMessage(attribute, _);
    },
    on: ['create']
  }];
};

var getRequiredErrorMessage = function getRequiredErrorMessage(attribute, _) {
  switch (attribute) {
    case 'id':
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: 'ID'
      }));

    default:
      return null;
  }
};

var getPatternMatchErrorMessage = function getPatternMatchErrorMessage(attribute, _) {
  switch (attribute) {
    case 'id':
      return "".concat(_(_messagesI18n.messages.paramToMatchPattern, {
        param: 'ID',
        chars: 'a-z 0-9 .'
      }));

    default:
      return null;
  }
};

exports.getPatternMatchErrorMessage = getPatternMatchErrorMessage;

var getValidationRules = function getValidationRules(scenario, _) {
  return apiValidationRules(_).filter(function (rule) {
    return !rule.on || rule.on && rule.on.indexOf(scenario) !== -1;
  });
};

exports.getValidationRules = getValidationRules;
//# sourceMappingURL=validation-rules.js.map